import loadScript from 'load-script'

export function getTrack(): Promise<any> {
  return new Promise((resolve, reject) => {
    if (!window.track) {
      loadScript(
        '//st.haiziwang.com/static/tracker/4.0.0/tracker.js',
        (err: any) => {
          if (err) {
            reject()
          } else {
            resolve(window.track)
          }
        }
      )
    } else {
      resolve(window.track)
    }
  })
}
//T1  pageLevelId  T2 代表clickid  T0代表bizType 之所以加是因为各个页面有可能不至于 不能在meta从取
export type CurriedTrackFunction<T0, T1, T2, T3, T4, T5, R> = (t0: T0, t1: T1, t2?: T2) => (t3?: T3, t4?: T4, t5?: T5) => R

function curryTrack<T0, T1, T2, T3, T4, T5, R>(
  f: (t0: T0, t1: T1, t2: any, t3: any, t4: any, t5: any) => R
): CurriedTrackFunction<T0, T1, T2, T3, T4, T5, R> {

  function curriedFunction(t0: T0, t1: T1, t2: any | undefined): any {
    return (t3: any = undefined, t4: any = undefined, t5: any = undefined): R => {
      return f(t0, t1, t2, t3, t4, t5)
    }
  }
  return curriedFunction
}

export type NewTrackFunction<T, R> = (t: T) => R
function curryNewTrack<T, R>(f: NewTrackFunction<T, R>){
  function newFunction(t: T): any {
    return f(t)
  }
  return newFunction
}

/**
 * 描述
 * @date 2020-11-19
 * @param {any} pageLevelId:string
 * @param {any} clickId:string|undefined 浏览上报时必需区块ID
 * @param {any} pageParam:any|undefined
 * @param {any} positionId:string|undefined
 * @param {any} positionParam:any|undefined
 * @returns {any}
 *   logType  meta 中没有时必需上报类型，默认从 <meta /> 中获取
 *     bizType 业务类型，默认从 <meta /> 中获取
 *    pageLevelId 页面ID，默认从 <meta /> 中获取
 *   clickId 非
 *   pageParam 页面参数（需在埋点配置系统配置参数模板）
 *   positionId 坑位编码
 *   positionParam 坑位内容参数
 *   cpm 自定义参数
 *   sourceId  来源编码，首次浏览上报时有效，默认从 url 中获取
 *   sourceParam 来源参数，首次浏览上报时有效，默认从 url 中获取
 */
function upTrack(
  bizType: string,
  pageLevelId: string,
  clickId: string | undefined,
  pageParam: any | undefined,
  positionId: string | undefined,
  positionParam: any | undefined
) {
  const logType: string = clickId ? '20000' : '10000'
  pageParam = pageParam ? JSON.stringify(pageParam) : undefined
  positionParam = positionParam ? JSON.stringify(positionParam) : undefined
  const params = {
    bizType,
    clickId,
    logType,
    pageLevelId,
    pageParam,
    positionId,
    positionParam
  }
  getTrack()
    .then((track) => {
      track._launch(params)
      rewriteExposureParams({ pageLevelId, bizType })
    })
    .catch((err) => {
      console.error(err)
    })
}

export interface TrackClickParms {
  bizType: string
  pageLevelId: string
  clickId?: string
  pageParam?: any
  positionId?: string
  positionParam?: any
}
export interface TrackViewParms {
  bizType: string
  pageLevelId: string
  pageParam?: any
}

function newClickUpTrack(
  parms: TrackClickParms
) {
  if (!parms.bizType || !parms.pageLevelId || !parms.clickId) {
    return
  }
  upTrack(parms.bizType, parms.pageLevelId, parms.clickId, parms.pageParam, parms.positionId, parms.positionParam)
}

function newViewUpTrack(
  parms: TrackClickParms
) {
  if (!parms.bizType || !parms.pageLevelId) {
    return
  }
  upTrack(parms.bizType, parms.pageLevelId, parms.clickId, parms.pageParam, parms.positionId, parms.positionParam)
}

/*
以下两种埋点方式均可使用
*/

//老埋点 统一埋点 
export const tracker = curryTrack(upTrack)

//新埋点 区分页面和点击埋点
export const newViewTracker = curryNewTrack(newViewUpTrack)
export const newClickTracker = curryNewTrack(newClickUpTrack)

//手动设置埋点sdk里面曝光上报的参数【现有的曝光埋点有缺陷，只会使用加载后第一次获取页面meta上的的page-id、biz-type等】
function rewriteExposureParams(params: any) {
  const { pageLevelId, bizType } = params
  /* 只在开启了曝光埋点且页面更改时才执行重写方法 */
  if (window._TRACK_EXPOSURE) {
    const isMap = Object.prototype.toString.call(window.visibleNodeList) == '[object Map]'
    if (isMap && window.visibleNodeList.pageLevelId !== pageLevelId) {
      /* 给map添加一个属性来判断页面是否发生变化 */
      window.visibleNodeList.pageLevelId = pageLevelId
      /* 重写sdk里面visibleNodeList变量的set方法，让被监听dom的上报一些参数为当前页面的参数 */
      window.visibleNodeList.set = function(key: any, value: any) {
        const isObject = Object.prototype.toString.call(value) == '[object Object]'
        if (isObject) {
          pageLevelId && (value.pagelevelid = pageLevelId)
          bizType && (value.biztype = bizType)
        }
        Map.prototype.set.call(this, key, value)
      }
      console.log('window.visibleNodeList', window.visibleNodeList)
    }
  }
}
